import { MessageDirection } from "@redotech/redo-marketing-common/message/marketing-message-definition";
import { MarketingChannel } from "@redotech/redo-model/marketing";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getDevConversation = {
  name: "getDevConversation" as const,
  input: z.object({ recoverConfigId: z.string() }),
  output: z.object({
    found: z.boolean(),
    messages: z.array(
      z.object({
        direction: createEnum(MessageDirection),
        content: z.string(),
        channel: z.literal(MarketingChannel.SMS),
      }),
    ),
  }),
};
